// src/env.js
export const ENV = (typeof process !== 'undefined' ? process.env : {}) || {};

export const AppEnv = ENV.VUE_APP_ENV || ENV.NODE_ENV || 'development';
export const ApiUrl = ENV.VUE_APP_API_URL || '/api';

export const Flags = Object.freeze({
  isDev: AppEnv === 'development',
  isProd: AppEnv === 'production',
  isNine: AppEnv === 'nine',
  isStaging: AppEnv === 'staging',
});
